// extracted by mini-css-extract-plugin
export var highlights = "style-mod--highlights--d6c9d";
export var highlightsItems = "style-mod--highlights-items--d0e88";
export var mobileTitle = "style-mod--mobile-title--60539";
export var title = "style-mod--title--264d7";